module.exports = __webpack_public_path__ + "img/communication2.566c14ca.png";